<template>
  <custom-dialog width="800px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <!-- 用户信息 -->
      <el-form :model="form" ref="form" :rules="rules">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('base_table_columns_dialog.suo_shu_ying_yong')" prop="appId">
              <custom-select v-model="form.appId" url="AppMenu" :props="{ label: 'appName', value: 'appId' }" :dataFilter="dataFilter" @change="form.menuId = ''"></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base_table_columns_dialog.suo_shu_cai_dan')" prop="menuId">
              <custom-select
                v-model="form.menuId"
                :listener="form.appId"
                url="MenuTree"
                type="tree"
                :auto="!!form.appId"
                :cascaderKey="form.appId"
                :params="{ appId: form.appId }"
                :show-all-levels="false"
                :props="{ label: 'menuName', value: 'menuId', checkStrictly: true, emitPath: false }"
              ></custom-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('base_table_columns_dialog.biao_ge_dai_ma')" prop="tableCode">
              <el-input v-model="form.tableCode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="saveColumn()" :loading="isLoad">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      isLoad: false,
      form: {
        menuId: '',
        appId: '',
        columnCode: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        appId: {
          required: true,
          message: this.$t('base_table_columns_dialog.ssyybx'),
        },
        menuId: {
          required: true,
          message: this.$t('base_table_columns_dialog.sscdbx'),
        },
        tableCode: [
          {
            required: true,
            message: this.$t('base_table_columns_dialog.bgdmbt'),
          },
          { max: 30, message: this.$t('Common.com_rules_length_max', [30]), },
        ],
      };
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    dataFilter: function (list) {
      return list.filter((t) => t.appCode !== 'isynergy_cloud');
    },
    // 初始化
    initDialog: function () {
      // this.resetForm = JSON.stringify(this.form);
      this.form.appId = this.model.data[0].appId || '';
      this.form.menuId = this.model.data[0].menuId || '';
      // if (this.model.type === 'edit') {
      //   const row = this.model.data.item;
      //   row.dicGroup = row.dicGroup || null;
      //   this.$setFormatData(this.form, row);
      // }
    },
    // 确认保存
    saveColumn: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        let i = 1;
        const list = JSON.parse(JSON.stringify(this.model.data));
        const myInterval = function (cb, interval, times) {
          const handle = setInterval(() => {
            cb(i);
            i++;
            times--;
            if (times <= 0) {
              clearInterval(handle);
            }
          }, interval);
        };
        const myHandle = (index) => {
          const form = Object.assign({}, list[index], {
            tableCode: this.form.tableCode,
            appId: this.form.appId,
            menuId: this.form.menuId,
            showOrder: index * 5,
          });
          this.saveAddColumn(form, list.length === index + 1);
        };
        this.isLoad = true;
        myHandle(0);
        myInterval(myHandle, 3000, list.length - 1);
      });
    },
    // 保存新增
    saveAddColumn: function (form, isOk) {
      this.$postJSON(apis.TableColumnAdd, form)
        .then(() => {
          if (isOk) {
            this.isLoad = false;
            this.$message({
              message: this.$t('Common.com_add_success'),
              type: 'success',
            });
            this.visible = false;
            this.$emit('success');
          }
        })
        .catch(() => {
          if (isOk) {
            this.isLoad = false;
          }
        });
    },
  },
};
</script>

<style lang="scss"></style>
